import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a CSS media query currently matches. `matchMedia` is an external
 * browser source, so this reads it through `useSyncExternalStore` — no effect
 * and no copy in state. `matchMedia` is used rather than `innerWidth` because
 * `innerWidth` follows pinch-zoom on tablets and would reflow mid-gesture.
 */
export function useMediaQuery(query: string): boolean {
    // useSyncExternalStore resubscribes whenever `subscribe` changes identity,
    // so it must stay stable per `query`.
    const subscribe = useCallback(
        (onChange: () => void) => {
            const list = window.matchMedia(query);
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        },
        [query]
    );
    const getSnapshot = () => window.matchMedia(query).matches;

    return useSyncExternalStore(subscribe, getSnapshot);
}
